<div class="bg-white border m-2 py-3 px-3 shadow-sm">
  <h5>Assign</h5>
  <era-device-link-selector [selection]="selection$ | async"
                            [isSpare]="false"
                            [isHousekeeping]="false"
                            (selectionChange)="updateSelection($event)">
  </era-device-link-selector>
  <button type="submit"
          id="device-assign-assign-button"
          class="btn btn-success me-2"
          (click)="assign()">Assign</button>
  <a type="cancel"
     id="device-assign-cancel-button"
     class="btn btn-outline-primary"
     [routerLink]="['../']">Cancel</a>
</div>